import { FormBuilder, FormControl } from '@angular/forms';

export enum FailedMessagesReportFieldValueEnum {
  Sc3Failed = 'SC3_FAILED',
  Sc4Failed = 'SC4_FAILED',
}

export class FailedMessagesReportFieldModel {
  value: FailedMessagesReportFieldValueEnum | null = null;
  title: string | null = null;
  required = false;

  constructor(params?: FailedMessagesReportFieldModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FailedMessagesProfileReportModel {
  fields: FailedMessagesReportFieldModel[] = [];

  constructor(params?: FailedMessagesProfileReportModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FailedMessagesProfileReportForm {
  constructor(
    model: FailedMessagesProfileReportModel,
    fb: FormBuilder = new FormBuilder(),
    public fields: FormControl<FailedMessagesReportFieldModel[]> = fb.control<FailedMessagesReportFieldModel[]>(
      model.fields,
      [],
    ),
  ) {}
}
